let appState = 'starting';
function getAppState() {
    return appState;
}
function setAppState(newState) {
    appState = newState;
}

export { getAppState, setAppState };
